import clsx from 'clsx';

import styles from './Notes.module.scss';

function Notes({
    children,
    notes,
    className,
    normal,
    result,
    disable,
    ...rest
}) {
    return (
        <div
            {...rest}
            className={clsx(
                styles.answer,
                result === 'right' && styles.right,
                result === 'wrong' && styles.wrong,
            )}
        >
            <div className={clsx(styles.label)}>Lưu ý:</div>
            <div className={clsx(styles.answerContent)}>
                {notes.map((note, index) => {
                    return <div key={`note_${index}`}>{note}</div>;
                })}
            </div>
        </div>
    );
}

export default Notes;
